import { MAX_ARTICLES_PER_COLLECTION, MAX_COLLECTIONS_PER_USER } from "@serophin/nottldr-shared";

/** "1 article", "3 articles". */
export const articleCount = (count: number): string => `${count} ${count === 1 ? "article" : "articles"}`;

/** The message of a failed call, or `fallback` when it carries none. */
export const errorMessage = (error: unknown, fallback: string): string => (error instanceof Error && error.message ? error.message : fallback);

/** The words the API uses when a limit is reached, so a refusal looks the same before and after the call. */
export const COLLECTION_LIMIT_MESSAGE = `You have reached the maximum of ${MAX_COLLECTIONS_PER_USER} collections`;
export const ARTICLE_LIMIT_MESSAGE = `You have reached the maximum of ${MAX_ARTICLES_PER_COLLECTION} articles per collection. Please delete some articles to add more.`;
